import compiler from "mson/lib/compiler";
import moment from "moment";
import ReactDOM from "react-dom";
import globals from "mson/lib/globals";
import "react-notifications/lib/notifications.css";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";

import { strings } from "./strings";
import TextField from "./textField";

import sha256 from "./sha256";

// eslint-disable-next-line
import {
  AuthStatus,
  // eslint-disable-next-line
  AuthStatusField,
  // eslint-disable-next-line
  CurrentFormField,
  CurrentForm,
} from "../components/mson";

import { loadFromBase } from "./scanAndSearch";

// eslint-disable-next-line
import ReaderButtonField from "../components/mson/ReaderButton";
import ReaderButtonFieldUI from "../components/mson/ReaderButtonUI";
// eslint-disable-next-line
import FormNavigationField from "../components/mson/FormNavigation";
import FormNavigationFieldUI from "../components/mson/FormNavigationUI";

import MSONUIComponents from "mson-react/lib/components";
import * as config from "../config.json";

MSONUIComponents.AuthStatus = AuthStatus;
MSONUIComponents.CurrentForm = CurrentForm;
MSONUIComponents.ReaderButtonField = ReaderButtonFieldUI;
MSONUIComponents.FormNavigationField = FormNavigationFieldUI;

const readerButton = compiler.newComponent({
  name: "ReaderButton",
  value: "foo",
  component: "ReaderButtonField",
});
const ArrivalDateField = compiler.newComponent({
  name: "ArrivalDate",
  label: strings.todaysDateLabel,
  required: true,
  component: "DateField",
});
const scan = compiler.newComponent({
  component: "Form",
  name: "app.AgentForm",
  fields: [
    {
      name: "Auth",
      component: "AuthStatus",
    },
    {
      name: "CurrentForm",
      component: "CurrentForm",
    },
    {
      name: "DescriptionField",
      text: strings.descriptionLabel,
      component: "Text",
    },
    TextField("\n***\n"),
    {
      name: "FormNav",
      value: "foo",
      component: "FormNavigationField",
    },
    readerButton,
  ],
});

ArrivalDateField.on("$change", (e, v) => {
  if (e === "value") {
    // const dateVal = moment
    //   .utc(v)
    //   .tz("Pacific/Guam")
    //   .startOf("day")
    //   .toISOString();
  }
});

const lookupForm = async (code) => {
  const currentForm = await loadFromBase(code);
  if (currentForm) {
    return currentForm;
  } else {
    NotificationManager.error("Unable to find traveller", "", 10000);
    return false;
  }
};
const lookupAndRedirect = (formContext) => async (currentForm) => {
  if (currentForm) {
    formContext.setForm(currentForm);
    globals.redirect("/mark");
    return true;
  } else {
    NotificationManager.error(
      "Please check the customer details and search again.",
      "",
      10000
    );
    return false;
  }
};
scan["submit"] = async () => {
  const roleValue = localStorage.getItem("location-select");
  if (
    !roleValue ||
    roleValue === null ||
    roleValue === "null" ||
    roleValue === ""
  ) {
    NotificationManager.error(
      "Enter badge number and agent location prior to searching",
      "",
      10000
    );
    return false;
  } else {
    const formValues = scan.getValues();
    const formContext = formValues.CurrentForm;
    const dateVal = moment
      .utc(formValues["ArrivalDate"])
      .tz(config.timezone)
      .startOf("day")
      .toISOString();
    const baseString = `${dateVal};${formValues["DOBDayField"]}-${formValues["DOBMonthField"]}-${formValues["DOBYearField"]};-${formValues["PassportNoField"]};${formValues["PassportCountryField"]}`;
    const baseLookup = sha256(baseString);
    const currentForm = await lookupForm(baseLookup);
    await lookupAndRedirect(formContext)(currentForm);
  }
};
const enableProcess = () => {
  const roleValue = localStorage.getItem("location-select");
  if (
    !roleValue ||
    roleValue === null ||
    roleValue === "null" ||
    roleValue === ""
  ) {
    NotificationManager.error(
      "Enter badge number and agent location prior to scanning",
      "",
      10000
    );
    return false;
  } else {
    return true;
  }
};

const processScan = async (qrcode) => {
  const formValues = scan.getValues();
  const formContext = formValues.CurrentForm;
  const currentForm = await lookupForm(qrcode);
  if (currentForm) {
    return await lookupAndRedirect(formContext)(currentForm);
  } else {
    return false;
  }
};
scan.on("load", async () => {
  document.getElementById("buttonHolder").style.visibility = "visible";
  const notifier = <NotificationContainer />;
  ReactDOM.render(notifier, document.getElementById("app"));
  readerButton._set("ready", enableProcess);
  readerButton._set("processor", processScan);
});

// date of flight, date of birth, passport number and passport country
export default scan;
